import { typography } from '@shared/tokens/typography.stylex';
import { anatomy } from '@shared/tokens/anatomy.stylex';
import { colors } from '@shared/tokens/colors.stylex';
import { palette } from '@shared/tokens/palette.stylex';
import { keyframes } from '@stylexjs/stylex';
import { fonts } from '@shared/tokens/fonts.stylex';
import * as stylex from '@stylexjs/stylex';

const skeletonLoading = keyframes({
  '0%': {
    backgroundPosition: '200% 0',
  },
  '100%': {
    backgroundPosition: '-200% 0',
  },
});

export const styles = stylex.create({
  sidebar: {
    position: 'relative',
  },
  elementList: {
    display: 'flex',
    flexDirection: 'column',
    gap: anatomy['size-4'],
    width: '200px',
  },
  elementItem: {
    fontFamily: fonts.din2014Demi,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    padding: `${anatomy['size-8']} ${anatomy['size-16']}`,
    borderRadius: anatomy['size-8'],
    cursor: 'pointer',
    fontSize: typography['fontSizeCaption-1'],
    lineHeight: typography['lineHeightCaption-1'],
    color: colors.primaryText,
    background: colors.brandGhostBackground,
    position: 'relative',
    whiteSpace: 'nowrap',
    ':hover': {
      background: colors.brandGhostHoverBackground,
    },
  },
  plusIcon: {
    width: '18px',
    height: '18px',
    visibility: 'hidden',
  },
  plusIconVisible: {
    visibility: 'visible',
  },
  popup: {
    position: 'absolute',
    top: 0,
    left: '100%',
    marginLeft: anatomy['size-8'],
    zIndex: 9999,
    backgroundColor: colors.primaryBackground,
    borderRadius: anatomy['size-8'],
    boxShadow: `0 2px 8px ${palette['darked-10']}`,
  },
  popupContent: {
    padding: anatomy['size-16'],
  },
  skeletonItem: {
    height: '40px',
    borderRadius: anatomy['size-8'],
    background: `linear-gradient(90deg, ${colors.tertiaryBackground} 25%, ${colors.ghostBackground} 50%, ${colors.tertiaryBackground} 75%)`,
    backgroundSize: '200% 100%',
    animationName: skeletonLoading,
    animationDuration: '1.5s',
    animationTimingFunction: 'linear',
    animationIterationCount: 'infinite',
  },
});
